import { useQuery } from '@tanstack/vue-query';
import type { ComputedRef } from 'vue';
import type { BetHistoryEntity } from '@/common/api/model';
import Api from '@/common/api';

interface BetTransactionsParams {
  winningStatus?: string;
  isSettled?: number;
  pageSize?: number;
  pageNo: number;
}

interface BetTransactionsResponse {
  entityList: BetHistoryEntity[];
  totalNum: number;
}

/**
 * TanStack Query hook for fetching bet transactions
 */
export function useBetTransactions(params: ComputedRef<BetTransactionsParams>) {
  return useQuery({
    queryKey: ['betTransactions', params],
    queryFn: async () => {
      const response = await Api.getBetHistory({
        ...params.value,
        _t: +new Date(),
      });

      return response.data as BetTransactionsResponse;
    },
    // Keep data fresh for 30 seconds
    staleTime: 30000,
    // Cache data for 5 minutes
    gcTime: 5 * 60 * 1000,
  });
}
